import React from 'react';
import { OpportunityPage } from './pages/OpportunityPage';
export function App() {
  return <OpportunityPage data-id="element-0" />;
}